import { render, staticRenderFns } from "./ContactDetailView.vue?vue&type=template&id=0a20fba8&lang=pug"
import script from "./ContactDetailView.vue?vue&type=script&lang=ts"
export * from "./ContactDetailView.vue?vue&type=script&lang=ts"
import style0 from "./ContactDetailView.vue?vue&type=style&index=0&id=0a20fba8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a20fba8')) {
      api.createRecord('0a20fba8', component.options)
    } else {
      api.reload('0a20fba8', component.options)
    }
    module.hot.accept("./ContactDetailView.vue?vue&type=template&id=0a20fba8&lang=pug", function () {
      api.rerender('0a20fba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contacts/Contacts/ContactDetailView.vue"
export default component.exports